import { AbstractControl } from '@angular/forms';
import { getServerConfig } from '@app/origami-api/server-config';

export function passwordValidator(control: AbstractControl): { [key: string]: any } {
  const passwordValidationRegexp = getServerConfig().PasswordValidationRegexp;
  const value = control.value;
  const result = passwordValidationRegexp.test(value);
  return result ? null : { passwordValidator: { value } };
}
